'use client'

import Image from 'next/image'

import { useLineImage } from '../../../../hooks/useLineImage'
import type { ActiveLineType } from '../../../../types/activePurchases.types'

export const LineImage = ({ line }: { readonly line: ActiveLineType }) => {
	const image = useLineImage({ line })
	return image ? (
		<Image src={image} alt={line.id} priority fill sizes='140px' />
	) : null
}
